import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Plus = ({
  size,
  type,
  theme,
  className,
  dataTestId = "plus-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.66739 2.67474C8.66739 2.30655 8.36892 2.00807 8.00073 2.00807C7.63254 2.00807 7.33406 2.30655 7.33406 2.67474L7.33406 7.3331H2.67448C2.30629 7.3331 2.00781 7.63158 2.00781 7.99976C2.00781 8.36795 2.30629 8.66643 2.67448 8.66643H7.33406V13.3247C7.33406 13.6929 7.63254 13.9914 8.00073 13.9914C8.36892 13.9914 8.66739 13.6929 8.66739 13.3247V8.66643H13.3244C13.6926 8.66643 13.9911 8.36796 13.9911 7.99976C13.9911 7.63158 13.6926 7.3331 13.3244 7.3331H8.66739V2.67474Z"
    />
  </SVGIcon>
);
